import React, { memo } from 'react';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'; 

import { brand, brandSlug, titleEspecial, twitterAccount, urlBrand, urlCommonAssets, urlEspecial, urlPortadaEspeciales } from '../../Constants';

const Header = () => {

    return (
        <header className="container-fluid position-fixed top-0 p-0">
            <section className="d-flex justify-content-between align-items-center h-100 mx-auto ctn-header">
                <section className="align-middle ctn-logo">
                    <a className="d-inline-block mx-2 logo" href={urlBrand} target="_blank" rel="noreferrer">
                        <img className="img-fluid" src={`${urlCommonAssets}img/logo${brandSlug}.png`} alt={brand} loading="lazy" />
                    </a>
                    <i className="d-inline-block align-middle bg-white header-barra-2"></i>
                    <a className="d-inline-block fw-bold text-white boton-especiales" href={urlPortadaEspeciales} target="_blank" rel="noreferrer">
                        <span className="h5 fw-bold mx-1 align-middle cruz">+</span>ESPECIALES
                    </a>
                </section>
                <section className="social">
                    <ul className="list-group list-group-horizontal">
                        <li className="d-block mx-2">
                            <FacebookShareButton
                                url={urlEspecial}
                            >
                                <a className="text-white facebook" href="/#"><i className="icon-facebook"></i></a>
                            </FacebookShareButton>
                        </li>                  
                        <li className="d-block mx-2">
                            <WhatsappShareButton
                                url={urlEspecial}
                                title={titleEspecial}
                            >
                                <a className="text-white wst" href="/#"><i className="icon-whatsapp"></i></a>
                            </WhatsappShareButton>  
                        </li>          
                        <li className="d-block mx-2">
                            <TwitterShareButton
                                url={urlEspecial}
                                title={titleEspecial}
                                via={twitterAccount}
                            >
                                <a className="text-white tw" href="/#"><i className="icon-twitter"></i></a>
                            </TwitterShareButton>                            
                        </li>                        
                    </ul>
                </section>
            </section>
        </header>
    )
}

export default memo(Header);


